import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "./appBaseQuery";

export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: appBaseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  tagTypes: [
    "CaseGroups",
    "ClientGroups",
    "BusinessTeam",
    "CaseGroupDetail",
    "CaseGroupEntries",
    "GroupCaseEntry",
    "ClientGroupClients",
    "Cases",
    "CaseStats",
    "TagCases",
    "DocAudit",
    "CaseAudit",
    "ProofDocAudit",
    "Notifications",
    "TermsStatus",
  ],
  endpoints: () => ({}),
});
